import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/cardiology/dse";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	dse: {
		id: "ktx.dse.title",
		defaultMessage: "DSE (Dobutamin Stress ECHO)"
	},
	result: {
		id: "ktx.dse.field.result",
		defaultMessage:
			"Eredmény (Kérjük 50 éves kor feletti páciens esetén mindenképpen töltse ki az űrlapot)"
	},
	description: {
		id: "ktx.dse.field.description",
		defaultMessage: "Megjegyzés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	},
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: {
			type: "textarea",
			props: {}
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.description }] }
	]
};

export const node: LeafNode = {
	id: "ktx_dse",
	value: {
		schemaId: "dse",
		title: messages.dse,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
